import { render, staticRenderFns } from "./PassageChoiceEdit.vue?vue&type=template&id=caec3770&scoped=true"
import script from "./PassageChoiceEdit.vue?vue&type=script&lang=js"
export * from "./PassageChoiceEdit.vue?vue&type=script&lang=js"
import style0 from "./PassageChoiceEdit.vue?vue&type=style&index=0&id=caec3770&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caec3770",
  null
  
)

export default component.exports